<template>
  <CompanyWrapper>
    <Loading v-if="isLoading"></Loading>
    <NotEnglish v-if="isEnglishNotAvailable"></NotEnglish>
    <BadRequest :lang="lang" v-if="isBadRequest"></BadRequest>
    <main
      class="main"
      v-if="!isLoading && !isEnglishNotAvailable && !isBadRequest"
    >
      <!-- パンくずリスト -->
      <ol class="breadcrumb-trail__list">
        <li class="breadcrumb-trail__list--item">
          <router-link
            :to="{ path: `/${langPath}company/summary` }"
            class="breadcrumb-trail__list--item__link"
          >
            EventList
          </router-link>
        </li>
        <li class="breadcrumb-trail__list--item">
          <router-link
            :to="{ path: `/${langPath}company/event/${eventData.code}` }"
            class="breadcrumb-trail__list--item__link"
          >
            Detail
          </router-link>
        </li>
      </ol>
      <div class="main__title">
        <h1
          class="main__title--name"
          :style="`border-left: solid 8px ${eventData.text.event_color_code};`"
        >
          {{ eventData.name }}
        </h1>
        <figure class="main__title--figure">
          <img
            :src="`https://tmf-virtualrun.jp/images/company/${eventData.text.image_file_name}`"
            alt=""
            height="52"
          />
        </figure>
      </div>
      <ul class="event-category-label__list margin-top25">
        <li class="event-category-label__list--item">
          {{ eventData.text.event_label }}
        </li>
      </ul>
      <p
        class="event-description"
        v-html="eventData.text.detail_description"
      ></p>
      <p class="event-description update-time">{{
        eventData.text.update_day
      }}</p>
      <ul class="requirements-list">
        <li class="requirements-list__item">
          <dl class="requirements-list__item--dl">
            <dt class="item-team">
              {{ Event.name[lang] }}
            </dt>
            <dd class="detail-description">
              {{ eventData.name }}
            </dd>
          </dl>
        </li>
        <template v-if="eventData.texts">
          <li
            class="requirements-list__item"
            v-for="(detail, index) in eventData.texts[0].details"
            :key="index"
          >
            <dl class="requirements-list__item--dl">
              <dt class="item-team" v-html="detail.label"></dt>
              <dd class="detail-description" v-html="detail.value"></dd>
            </dl>
          </li>
        </template>
      </ul>
      <!-- エントリー対応 -->
      <!-- TODO Entry文言をコンテンツで付与して渡すことが望ましい -->
      <template v-if="isEntryLink && !eventData.text.entry_page_flag">
        <a
          :href="`${eventData.text.entry_page_url}`"
          class="more-link icon-target-blank"
          target="_blank"
          rel="noopener"
        >
          Entry
        </a>
      </template>
      <template v-else>
        <div class="more-link icon-target-blank gray-out"> Entry </div>
      </template>
      <!-- ランキング対応 -->
      <router-link
        v-if="isResultLink"
        :to="{
          path: `/${langPath}company/ranking`,
          query: { event: eventId, page: 1 },
        }"
        class="more-link"
      >
        View Result
      </router-link>
      <div class="more-link gray-out" v-else> View Result </div>
      <!-- OAuth対応 -->
      <!-- TODO 後でリファクタ必須（コンポーネントに分割するなど） -->
      <router-link
        v-if="isOauthLink"
        :to="{
          path: `/${langPath}company/confirmation`,
          query: { event: eventId },
        }"
        class="more-link text-center"
      >
        {{ Event.link[lang] }}
      </router-link>
      <!-- 期間外 -->
      <div v-else class="more-link text-center gray-out">
        {{ Event.link[lang] }}
      </div>
      <router-link
        :to="{ path: `/${langPath}company/howtojoin` }"
        class="more-link oauth text-center"
      >
        {{ Event.howtojoin[lang] }}
      </router-link>
      <router-link
        :to="{ path: `/${langPath}company/question` }"
        class="more-link oauth text-center"
      >
        {{ Event.question[lang] }}
      </router-link>
    </main>
  </CompanyWrapper>
</template>

<script>
import CompanyWrapper from "../../../../components/sp/company/CompanyWrapper";
import Loading from "../../../../components/sp/Loading";
import BadRequest from "../../../../components/common/status/BadRequest";
import NotEnglish from "../../../../components/sp/NotEnglish";
import Event from "../../../../assets/constants/event/event.json";
import { RepositoryFactory } from "../../../../api/RepositoryFactory";
import cognito from "../../../../plugins/cognito";

export default {
  data() {
    return {
      eventData: {},
      isLoading: true,
      eventId:
        this.$route.path.split("/")[1] === "en"
          ? this.$route.path.split("/")[4]
          : this.$route.path.split("/")[3],
      isEntryLink: false,
      isOauthLink: false,
      isResultLink: false,
      isEnglishNotAvailable: false,
      isBadRequest: false,
    };
  },
  async created() {
    // イベント詳細を取得
    const EventRepository = RepositoryFactory.get("event");
    const isCompany = this.$route.path.includes("company");
    const params = {
      code:
        this.$route.path.split("/")[1] === "en"
          ? this.$route.path.split("/")[4]
          : this.$route.path.split("/")[3],
      lang: this.lang,
      is_company_event: isCompany || "",
      company_user_name: cognito.getUserName() || "",
    };
    let response;
    try {
      response = await EventRepository.getEvent(params);
    } catch (e) {
      if (e.response.status === 400) {
        this.isBadRequest = true;
        this.isLoading = false;
      }
      return;
    }
    this.eventData = response.data;

    // Entry期間
    this.isEntryLink = this.eventData.text.entry_date_flag;
    // OAuth期間
    this.isOauthLink = this.eventData.text.oauth_date_flag;
    // ランキング
    this.isResultLink = this.eventData.text.result_date_flag;

    // 英語ページの場合表示するかを判定
    if (this.lang === "en" && this.eventData.text.english_page_flag) {
      this.isEnglishNotAvailable = true;
    }

    this.isLoading = false;
  },
  computed: {
    Event: function () {
      return Event;
    },
    lang: function () {
      return this.$store.state.lang;
    },
    langPath: function () {
      return this.$store.state.langPath;
    },
  },
  components: {
    CompanyWrapper,
    Loading,
    BadRequest,
    NotEnglish,
  },
  name: "Event",
};
</script>

<style scoped>
.main {
  &__title {
    margin: 40px 0 0 0;
    display: flex;
    align-items: center;
    &--name {
      line-height: 1.25;
      margin: 0;
      padding: 0 0 0 15px;
      font-size: 24px;
      font-weight: 900;
    }
  }
  .event-description {
    margin: 25px 0 0 0;
    line-height: 1.7;
    font-size: 14px;
    font-weight: 500;
  }
  .update-time {
    text-align: right;
  }
  .requirements-list {
    margin: 25px 0 40px 0;
    border-top: solid 1px var(--grayColor3);
    border-left: solid 1px var(--grayColor3);
    border-right: solid 1px var(--grayColor3);
    &__item {
      &--dl {
        .item-team {
          padding: 20px;
          border-bottom: solid 1px var(--grayColor3);
          line-height: 1.2;
          font-size: 24px;
          font-weight: bold;
          background-color: var(--defaultGrayColor);
        }

        .detail-description {
          padding: 20px;
          border-bottom: solid 1px var(--grayColor3);
          line-height: 1.5;
          font-size: 16px;
          font-weight: 500;
        }
      }
    }
  }
  .more-link {
    margin: 0 0 40px 0;
    padding: 18px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: solid 1px var(--defaultBlackColor);
    font-size: 20px;
    font-weight: 500;
    color: var(--defaultBlackColor);
  }
  .gray-out {
    border: solid 1px var(--grayColor4);
    color: var(--grayColor4);
  }
  .icon-target-blank {
    background: url("../../../../assets/images/target-blank.svg") no-repeat
      right 20px center;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/sp/company/event/Event.vue